<template>
	<div>
		<div class="page-filter-box">
			<el-row :gutter="20">
				<el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="4">
					<el-input v-model="params.searchValue" class="input-with-select" size="small">
						<el-select v-model="params.searchType" slot="prepend" placeholder="请选择">
							<el-option label="演出ID" :value="1"></el-option>
							<el-option label="用户ID" :value="2"></el-option>
						</el-select>
					</el-input>
				</el-col>
				<el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="4">
					<el-select v-model="params.auditStatus" placeholder="请选择" size="small">
						<el-option label="不限制审核状态" :value="-1"></el-option>
						<el-option label="仅查看待审核的" :value="1"></el-option>
						<el-option label="仅查看未通过的" :value="3"></el-option>
						<el-option label="仅查看已通过的" :value="2"></el-option>
					</el-select>
				</el-col>
				<el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="4" class="page-filter-btns">
					<el-button type="primary" icon="el-icon-search" @click="search" size="small">查询</el-button>
					<el-button type="default" icon="el-icon-refresh" @click="reset" size="small">重置</el-button>
					<el-button v-if="$utils.have('/smsMarketing/audit/export')" type="primary" icon="el-icon-download" size="small"
					    @click="download" :loading="downLoading">导出</el-button>
				</el-col>
			</el-row>
		</div>
		<div class="page-list-box">
			<el-table :data="dataList" border style="width: 100%" v-loading="listLoading" size="small" stripe>
				<el-table-column prop="smsTaskId" label="短信任务ID" min-width="180"></el-table-column>
				<el-table-column prop="activityId" label="演出ID"></el-table-column>
				<el-table-column prop="userId" label="用户ID"></el-table-column>
				<el-table-column prop="userName" label="用户名称" min-width="120"></el-table-column>
				<el-table-column prop="activityTitle" label="营销演出名称" min-width="200"
					show-overflow-tooltip></el-table-column>
				<el-table-column prop="smsContent" label="短信内容" min-width="200" show-overflow-tooltip></el-table-column>
				<el-table-column label="发送用户数" min-width="120">					
					<template slot-scope="scope">
						<div v-if="scope.row.isSmsBundle != 1">
							<p>圈层1： {{scope.row.circleNum1}}</p>
							<span>圈层2： {{scope.row.circleNum2}}</span>
						</div>							
						<p v-else>人数：{{scope.row.circleNum1}}</p>
					</template>
				</el-table-column>
				<el-table-column prop="feeAmount" label="预计费用"></el-table-column>
				<el-table-column prop="feeType" label="计费方式">					
				</el-table-column>				
				<el-table-column prop="createTime" label="提交时间"  min-width="140"></el-table-column>
				<el-table-column prop="pricipleName" label="项目负责人" min-width="140"></el-table-column>
				<el-table-column prop="auditStatus" label="审核状态"  min-width="100">
					<template slot-scope="scope">
						<span v-if="scope.row.auditStatus == 1">待审核</span>
						<span v-else-if="scope.row.auditStatus == 2" class="color-success">审核通过</span>
						<span v-else-if="scope.row.auditStatus == 3" class="color-danger">
							<el-popover placement="top-start" width="400" trigger="click"
								:content="scope.row.refuseReason">
								<span class="color-danger el-icon-thumb hand" slot="reference">审核拒绝</span>
							</el-popover>
						</span>
					</template>
				</el-table-column>
				<el-table-column label="发送时间" min-width="220">
					<template slot-scope="scope">
						<template v-if="scope.row.sendTime || scope.row.scheduledSendTime">
							<span v-if="scope.row.sendTime">
								{{ scope.row.sendTime }}
							</span>
							<span v-else>
								{{ scope.row.scheduledSendTime }} <span class="color-danger">(定时发送)</span>
							</span>
						</template>						
					</template>
				</el-table-column>
				<el-table-column fixed="right" label="操作" width="200">
					<template slot-scope="scope">
						<template v-if="scope.row.auditStatus ==1">
							<el-button type="text" size="small" @click="pass(scope.row.id)"
								icon="el-icon-success">通过</el-button>
							<span @click="refusePop(scope.row.id)" class="color-danger ML10 hand"><i class="el-icon-error"></i> 拒绝</span>
						</template>
						<el-button type="text" size="small" icon="el-icon-s-data" @click="toData(scope.row.id)"
							v-if="scope.row.auditStatus == 2">数据</el-button>
					</template>
				</el-table-column>
			</el-table>
		</div>
		<div v-if="data" class="page-pagination-box">
			<el-pagination background @size-change="handleSizeChange" @current-change="getDataList"
				:current-page.sync="params.pageNo" :page-sizes="$pageSizes" :page-size.sync="params.pageSize"
				layout="total, sizes, prev, pager, next" :total="data.totalCount || 0">
			</el-pagination>
		</div>
		<el-dialog width="350px" title="拒绝理由" :visible.sync="dialogVisible"  append-to-body>
			<el-input v-model.trim="refuseReason" type="textarea" :rows="2" maxlength="100" show-word-limit></el-input>
			<span slot="footer" class="dialog-footer">
				<el-button @click="dialogVisible = false" size="small">取 消</el-button>
				<el-button type="primary" @click="refuseSub()" size="small">确 定</el-button>
			</span>
		</el-dialog>
	</div>
</template>

<script>
	import {downloadFileTmp} from '@/assets/js/commonApi';
	const defaultParams = {
		pageNo: 1,
		searchType: 1,
		searchValue: '',
		auditStatus: -1,		
	}
	export default {
		components: {},
		data() {
			return {
				data: null,
				dataList: null,
				params: {
					...defaultParams,
					pageNo: parseInt(this.$route.query.pageNo || 1),
					pageSize: parseInt(this.$route.query.pageSize || this.$pageSizes[0]),
					searchType: parseInt(this.$route.query.searchType || 1),
					searchValue: this.$route.query.searchValue || '',					
				},

				listLoading: false,
				dialogVisible: false,
				refuseReason: '',
				downLoading:false

			}
		},
		mounted() {
			this.getDataList();
		},
		methods: {
			
			//获取列表
			getDataList() {
				this.listLoading = true;
				this.$request({
						url: "/smsMarketing/audit/list",
						method: "POST",
						data: {
							...this.params
						},
					})
					.then((res) => {
						const {
							state,
							msg,
							result
						} = res.data;
						if (state == 1 && result) {
							this.data = result;
							this.dataList = result.result || [];
						} else {
							this.$message.error(msg || "请求失败");
						}
					})
					.catch(() => {
						this.$message.error("请求错误");
					})
					.finally(() => {
						this.listLoading = false;
					});
			},
			//选择pageSize
			handleSizeChange(e) {
				this.params.pageNo = 1;
				this.params.pageSize = e;
				this.getDataList();
			},
			//搜索
			search() {
				this.params.pageNo = 1;
				this.getDataList();
			},
			//重置搜索
			reset() {				
				this.params = {
					...defaultParams,
					pageSize: this.params.pageSize,
				};
				this.getDataList();
			},
			//审核
			pass(id) {
				this.$confirm('确定要通过审核吗?', '提示', {
					type: 'warning',
					center: true,
					closeOnClickModal: false
				}).then(() => {
					this.$request({
							url: '/smsMarketing/audit',
							params: {
								id: id,
								status: 2,
							},
							method: "post",
						})
						.then((res) => {
							const {
								state,
								msg
							} = res.data;
							if (state == 1) {
								this.$message.success("操作成功");
								this.getDataList()
							} else {
								this.$message.error(msg || "请求失败");
							}
						})
						.catch(() => {
							this.$message.error("请求错误");
						})
				}).catch(() => {
				
				})
			},
			refusePop(id) {
				this.dialogVisible = true;
				this.refuseId = id
			},
			refuseSub() {
				if( this.refuseReason == '' ){
					return this.$message.error("拒绝理由不能为空！");
				}
				this.$request({
					url: '/smsMarketing/audit',
					params: {
						id: this.refuseId,
						status: 3,
						refuseReason: this.refuseReason
					},
					method: "post",
				}).then(res => {
					const {
						state,
						msg
					} = res.data;
					if (state == 1) {
						this.$message.success("操作成功");
						this.getDataList()
						this.dialogVisible = false
						this.refuseReason = ''
					} else {
						this.$message.error(msg || "请求失败");
						this.dialogVisible = false
						this.refuseReason = ''
					}
				})
			},
			toData(id) {
				this.$router.push({
					path: `/smsmarketing/fbaudit/statistics/${id}`,
				});
			},
			//导出
			async download(){
			    let filePath;
			    this.downLoading = true;
			    const res = await this.$request({
			        url:'/smsMarketing/audit/export',
			        method: 'post',
			        data: {
			            ...this.params      
			        },
			    })
			        .catch(err => {
			            this.$message({message: err.message, type: 'error'});
			        })
			    const{state,msg,result} = res.data;
			    if(state == 1 && result){
			        filePath = result.url;
			    }else{
			        this.downLoading = false;
			        return this.$message.error(msg || '下载失败');
			    }   
			
			    await downloadFileTmp(filePath,result.fileName + '.'+this.$utils.getFileType(filePath));
			    this.downLoading = false;
			}      
		}
	}
</script>

<style lang="scss" scoped>

</style>